/**
    ```
    Performs a shallow compare of the primitive props.
    An optimization suitable for a React.Component.shouldComponentUpdate
    where the reference type values does not change.
    ```
*/
export function shallowPrimitiveCompare(nextProps, prevProps) {
    return Object.entries(nextProps).some(([k, v]) => isPrimitive(v) && prevProps[k] !== v);
}
function isPrimitive(value) {
    return typeof value === "string"
        || typeof value === "number"
        || typeof value === "boolean"
        || typeof value === "undefined";
}
//# sourceMappingURL=shallowPrimitiveCompare.js.map